import React, { useEffect } from 'react'
import { Box, Button, Typography } from '@mui/material'

import OrbitSession from '../../hooks/useCookies'

export default function PaymentSuccess() {
  useEffect(() => {
    setTimeout(closeWindow, 5000)
  }, [])

  const closeWindow = async () => {
    switch (OrbitSession.get('paymentWindow')) {
      case 'neworder':
        window.opener.location.replace('app/orders')
        break
      case 'billing':
        window.opener.location.replace('app/billing')
        break
      case 'quotation':
        window.opener.location.replace('app/quotations')
        break
      case 'onboarding':
        window.opener.location.replace('app/order-success')
        break
      default:
        window.opener.location.replace('app')
        break
    }

    OrbitSession.del('paymentWindow')
    window.close()
  }
  return (
    <Box height='100vh'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          padding: `0px 16px`
        }}
      >
        <Box sx={{ textAlign: 'center', marginBottom: '48px', width: '60%' }}>
          <Typography variant='h4' sx={{ marginBottom: '48px' }}>
            Your payment has been completed successfully. Please wait while we
            redirect you back to Orbit
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            direction: 'column',
            justifyContent: 'center',
            width: '60%'
          }}
        >
          <Button
            variant='filled'
            onClick={() => closeWindow()}
            width='100%'
            sx={{ marginTop: '40px' }}
          >
            Close and redirect now
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
